export const colorPrimaryLight = "#D8FBE9";
export const colorPrimary = "#20AB8A";
export const colorPrimaryDark = "#007b5d";
export const colorSecondaryLight = "#ff8851";
export const colorSecondary = "#fd5523";
export const colorSecondaryDark = "#c21900";